<template>
  <div class="home-container">
    <div class="home-box">
      <!-- 轮播图 -->
      <div class="carousel-container">
        <el-carousel height="407px" :interval="5500">
          <el-carousel-item v-for="item in bannerList"  :key="item.id">
            <img @click="goLink(item.link)" :src="item.image" alt="" style="cursor: pointer; width: 100%;height:100%;">
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 搜索 -->
      <div class="search-container">
        <el-input class="search-input" placeholder="请输入搜索词" prefix-icon="el-icon-search" v-model="searchWord"
          @keyup.enter.native="toSearchNews">
          <el-select v-model="searchType" slot="append" placeholder="请选择" @change="toSearchNews">
            <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-input>
      </div>
      <div class="search-result-container">
        <div v-if="(!resultList || !resultList.length) && isSearch" class="empty-container">
          <img src="../../assets/empty.svg" alt="暂无数据">
          <div>没有搜索内容</div>
        </div>
        <div v-else class="search-result-list">
          <div v-for="(item,index) in resultList" :key="item.id" class="search-result-item"
            :style="{'margin-left': index > 0 ? '44px' : '0'}">
            <NewsItemVertical :news-info="item" @toViewDetail="toViewDetail" />
          </div>
        </div>
      </div>
      <!-- 资讯专区 -->
      <div class="news-container">
        <div class="news-title-container">
          <div class="news-title-img">
            <img src="../../assets/news.svg" alt="">
            <span class="news-title">资讯专区</span>
          </div>
          <div class="view-more" @click="toViewMore('news')">查看更多</div>
        </div>
        <div class="news-tip">
          掌握跨境tiktok服务电商行业资讯内容，把握tiktok平台海外商机
        </div>
        <div class="news-list-container">
          <div v-for="(item,index) in newsList" :key="item.id" class="search-result-item"
            :class="{'bottom': index < 4,'right':index !== 3 && index!==7}">
            <NewsItemVertical :news-info="item" @toViewDetail="toViewDetail" />
          </div>
        </div>
        <div class="tag-container">
          <div v-for="item in tagList" :key="item.id" class="tag-item" @click="toClickTag('detail',item)">{{ item.title
            }}</div>
          <div class="tag-item" @click="toClickTag('page')">
            <span>查看更多</span>
            <img src="../../assets/right-arrow.svg" alt="">
          </div>
        </div>
      </div>
      <div class="tools-hotnews">
        <div class="tools-container">
          <div class="news-title-container">
            <div class="news-title-img">
              <img src="../../assets/ruler.svg" alt="">
              <span class="news-title">行业工具</span>
            </div>
            <div class="view-more" @click="toViewMore('tools')">查看更多</div>
          </div>
          <div class="news-tip">
            开启TikTok平台海外掘金之旅，构建TK跨境电商服务行业新标杆
          </div>
          <div class="horizon-img-container">
            <!-- 占位 -->
            <div class="placeholder-img" v-if="!toolsMidImgList.length" v-for="(item) in 2" :key="item"
              :class="{'right':item === 2}">
            </div>
            <el-image class="horizon-img" @click="goLink(item.link)" v-show="toolsMidImgList.length" v-for="(item,index) in toolsMidImgList"
              fit="cover" :key="item.id" :src="item.image" :class="{'right':index == 1}">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <!-- <img class="horizon-img" v-for="(item,index) in toolsMidImgList" :src="item.cover" :alt="item.title" :key="item.id" :class="{'right':index == 1}"> -->
          </div>
          <div class="horizon-big-img">
            <img v-if="toolsBigImgInfo.id" @click="goLink(toolsBigImgInfo.link)" :src="toolsBigImgInfo.image">
            <div v-else class="placeholder-big-img"></div>
          </div>
        </div>
        <div class="hotnews-container">
          <div class="news-title-container">
            <div class="news-title-img">
              <img src="../../assets/tag.svg" alt="">
              <span class="news-title">TK服务</span>
            </div>
            <div class="view-more" @click="toViewMore('serviceMarekt')">查看更多</div>
          </div>
          <div class="news-tip">
            TikTok跨境电商每日热搜榜，TK行业新闻早知道
          </div>
          <div class="goodslist-container">
            <div v-for="item in goodsList" :key="item.id" class="goodslist-item">
              <GoodsItem :goods-info="item" @toDetail="toGoodsDetail" />
            </div>
          </div>
        </div>
      </div>
      <div class="cooperation-container">
        <div class="cooperation-title">
          <img class="cooperation-svg" src="../../assets/link.svg" alt="">
          <span class="news-title">合作伙伴</span>
        </div>
        <!-- 滚动区 -->
        <div class="cooperation-scroll-container">
          <ImageScroll :imgList="scrollImgList"></ImageScroll>
        </div>
      </div>
    </div>
    <div class="contact-box">
      <Contact />
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import NewsItemVertical from "@/components/NewsItemVertical"
  import GoodsItem from "@/components/GoodsItem"
  import ImageScroll from "@/components/ImageScroll"
  import { getBanner, getArticleList, getArticleCategory, getGoodsList } from "@/api/home"
  import Contact from "@/components/Contact"
  export default {
    name: 'Home',
    components: {
      NewsItemVertical,
      GoodsItem,
      ImageScroll,
      Contact
    },
    data() {
      return {
        bannerList: [],
        categoryList: [],
        searchWord: '',
        searchType: 1,
        isSearch: false,
        resultList: [],
        newsList: [],//资讯列表
        tagList: [],
        toolsMidImgList: [],//行业工具中图
        toolsBigImgInfo: {},// 行业工具大图
        goodsList: [],
        scrollImgList: []
      }
    },
    created() {
      this.$router.push('/')
      this.getBannerList()
      this.getCategory()
      this.getNewsList()
      this.getToolsList()
      this.getGoodsList()
      this.getCooperationList()
    },
    methods: {
      goLink (link) {
        window.open(link)
      },
      toGoodsDetail(item) {
        this.$router.push({
          name: 'GoodsDetail',
          params: {
            id:item.id
          }
        })
      },
      toViewMore(type) {
        let routeName = ''
        switch (type) {
          case 'news':
            routeName = 'News'
            break
          case 'tools':
            routeName = 'Tools'
            break
          case 'serviceMarekt':
            routeName = 'ServiceMarket'
            break
        }
        this.$router.push({
          name: routeName
        })
      },
      toClickTag(type, item) {
        if (type === 'detail') {
          this.$router.push({
            name: 'NewsDetail',
            params: {
              id: item.id
            }
          })
        } else {
          this.$router.push({
            name: 'News'
          })
        }
      },
      toViewDetail(newsItem) {
        this.$router.push({
          name: 'NewsDetail',
          params: {
            id: newsItem.id
          }
        })
      },
      //热榜
      async getGoodsList() {
        getGoodsList({
          category_id: '',
          sort: "sell_count"
        }).then(res => {
          if (res.data.data) {
            if (res.data.data.length > 7) {
              this.goodsList = res.data.data.slice(0, 6)
            } else {
              this.goodsList = res.data.data
            }
          }
        })
      },
      async getCooperationList() {
        const { data } = await getBanner({
          type: 4
        })
        console.log(data,'getCooperationList')
        if (data.length) {
          this.scrollImgList = data
        }
      },
      // 行业工具
      async getToolsList() {
        const { data } = await getBanner({
          type: 3
        })
        if (data.length) {
          this.toolsMidImgList = data.slice(0, 2)
          this.toolsBigImgInfo = data.slice(2, 3)[0]
        }
      },
      //资讯
      async getNewsList() {
        let newsList = await this.getArticleList({
          type_id: ''
        })
        if (newsList.length && newsList.length > 8) {
          this.newsList = newsList.slice(0, 8)
          this.tagList = newsList.slice(8).map(item => {
            return {
              title: item.title.length > 9 ? item.title.substring(0, 9) + '...' : item.title,
              id: item.id
            }
          })
        } else {
          this.newsList = newsList
          this.tagList = newsList.map(item => {
            return {
              title: item.title.length > 9 ? item.title.substring(0, 9) + '...' : item.title,
              id: item.id
            }
          })
        }
      },
      // 查询
      async toSearchNews() {
        this.isSearch = true
        const data = await this.getArticleList({
          type_id: this.searchType,
          keyword: this.searchWord
        })
        if (data.length && data.length > 5) {
          this.resultList = data.slice(0, 4)
        } else {
          this.resultList = data
        }
      },
      getCategory() {
        getArticleCategory().then(res => {
          if (res.data) {
            this.categoryList = res.data
          }
        })
      },
      getArticleList(params = {}) {
        return new Promise((resolve, reject) => {
          getArticleList(params).then(res => {
            if (res.data.data) {
              resolve(res.data.data)
            }
          })
        })
      },
      getBannerList() {
        getBanner({ type: 2 }).then(res => {
          if (res.data) {
            this.bannerList = res.data
          }
        })
      }
    }
  }
</script>
<style scoped lang="less">
  @import "~@/styles/var.less";
  @import "~@/styles/mixin.less";

  .home-container {
    width: 100%;
    position: relative;
  }

  .home-box {
    width: 1200px;
    margin: 25px auto 73px;
  }

  .carousel-container {
    height: 407px;
    border-radius: 20px;
    overflow: hidden;
    z-index: 10;
    position: relative;
  }

  .search-container {
    margin: 32px 31px;
    border-radius: 14px;
    overflow: hidden;
  }

  .search-result-container {
    padding: 0 31px;
    margin-bottom: 43px;
  }

  .search-result-list,
  .news-list-container {
    display: flex;
    flex-wrap: wrap;
  }

  .search-result-item {
    width: 250px;
  }

  .search-result-item.right {
    margin-right: 40px;
  }

  .search-result-item.left {
    margin-left: 40px;
  }

  .search-result-item.bottom {
    margin-bottom: 23px;
  }

  .empty-container {
    width: 200px;
    margin: 0 auto;
    text-align: center;
  }

  .news-tip {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: @tipwords;
    line-height: 20px;
    margin-top: 10px;
    margin-bottom: 23px;
  }

  .news-container {
    width: 100%;
    background: #fff;
    border-radius: 20px;
    padding: 27px 36px;
    box-sizing: border-box;
  }

  .news-title-container {
    display: flex;
    justify-content: space-between;
  }

  .news-title-img {
    display: flex;
    align-items: center;
  }

  .news-title-img img {
    margin-right: 10px;
  }

  .news-title {
    font-size: 20px;
    font-weight: 600;
    color: @words;
  }

  .view-more {
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    color: @tipwords;
  }

  .tag-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 38px;
  }

  .tag-item {
    margin-right: 39px;
    margin-bottom: 25px;
    padding: 6px 25px;
    border-radius: 8px;
    border: 1px solid #979797;
    font-size: 15px;
    font-weight: 600;
    color: @darkwords;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .tag-item img {
    margin-left: 2px;
  }

  .tools-hotnews {
    width: 100%;
    margin-top: 50px;
    display: flex;
  }

  .tools-container {
    width: 506px;
  }

  .tools-container,
  .hotnews-container {
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    padding: 25px 40px 35px 35px;
    box-sizing: border-box;
  }

  .horizon-img-container {
    width: 100%;
    height: 270px;
    font-size: 0;
  }

  .horizon-img {
    width: 200px;
    height: 100%;
    font-size: 14px;
    cursor: pointer;
  }

  .horizon-img.right,
  .placeholder-img.right {
    margin-left: 26px;
  }

  .placeholder-img {
    width: 200px;
    height: 100%;
    display: inline-block;
    background-color: @placeholderImgColor;
  }

  .horizon-big-img {
    width: 426px;
    height: 247px;
    margin-top: 18px;
    cursor: pointer;
  }

  .horizon-big-img img {
    width: 100%;
    height: 100%;
  }

  .placeholder-big-img {
    width: 100%;
    height: 100%;
    background: @placeholderImgColor;
  }

  .hotnews-container {
    width: 654px;
    margin-left: 42px;
    padding-bottom: 0;
  }

  .goodslist-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .goodslist-item {
    width: 166px;
    margin-bottom: 40px;
  }

  .cooperation-container {
    width: 100%;
    height: 160px;
    background: #FFFFFF;
    border-radius: 20px;
    overflow: hidden;
    box-sizing: border-box;
    margin-top: 54px;
  }

  .cooperation-title {
    margin-left: 40px;
    margin-top: 25px;
    display: flex;
  }

  .cooperation-svg {
    margin-right: 8px;
  }

  .cooperation-scroll-container {
    padding: 17px 40px;
    overflow: hidden;
  }

  .contact-box {
    .contact-box()
  }
</style>
<style lang="less">
  @import "~@/styles/var.less";

  .search-input input {
    border: 3px solid #3998FE;
    overflow: hidden;
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
    color: @words;
    font-size: 16px;
  }

  .search-input input::placeholder {
    color: #D6D6D6;
    font-size: 16px;
  }

  .search-input .el-input-group__append {
    width: 191px;
    border: none;
    background: #3998FE;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    box-sizing: border-box;
  }

  .search-input .el-select .el-input .el-select__caret {
    color: #fff;
  }

  .search-input .el-input__prefix {
    color: #D6D6D6;
  }

  .search-input .el-input__inner {
    height: 50px;
    line-height: 50px;
  }
</style>